import { BASEAPI } from 'src/api/api';

const unwrap = (response) => response.data?.result;

const requestError = (error, fallback) => {
  const raw = error?.response?.data?.error_message
    || error?.response?.data?.detail
    || error?.message
    || fallback;
  const message = typeof raw === 'string' ? raw : Object.values(raw || {}).flat().join(' ');
  const wrapped = new Error(message || fallback);
  wrapped.status = error?.response?.status;
  wrapped.fields = error?.response?.data?.error_message;
  wrapped.aborted = error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError' || error?.name === 'AbortError';
  return wrapped;
};

const compactParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
);

export const vehicleListApi = {
  getList: async (params = {}, { signal } = {}) => {
    try {
      const response = await BASEAPI({
        method: 'GET',
        url: 'vehicles/vehicle/',
        params: compactParams(params),
        signal,
      });
      return unwrap(response);
    } catch (error) {
      throw requestError(error, 'Unable to load vehicles.');
    }
  },
  exportList: async (params = {}) => {
    try {
      const response = await BASEAPI.get('vehicles/vehicle/', {
        params: compactParams({ ...params, export: true }),
        responseType: 'blob',
        timeout: 20000,
      });
      return response.data;
    } catch (error) {
      throw requestError(error, 'Unable to export vehicles.');
    }
  },
  createVehicle: async (data) => {
    try {
      const response = await BASEAPI({
        method: 'POST',
        url: 'vehicles/vehicle/',
        data,
      });
      return unwrap(response);
    } catch (error) {
      throw requestError(error, 'Unable to create the vehicle.');
    }
  },
};

export const createListRequestGuard = () => {
  let sequence = 0;
  let controller = null;

  return {
    next() {
      sequence += 1;
      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      return { id: sequence, signal: controller?.signal };
    },
    isCurrent(id) {
      return id === sequence;
    },
    abort() {
      if (controller) controller.abort();
    },
  };
};
